// frontend/src/features/regions/services/regionsAPI.ts
import api from '../../../services/apiConfig';
// --- MODIFICAÇÃO INÍCIO ---
import { DatePreset } from '../../../stores/filterStore';
// --- MODIFICAÇÃO FIM ---

export interface StateData {
    ESTADO: string;
    totalVenda: number;
    totalMargem: number;
    totalPares: number;
    participacao: number;
}

export interface RegionsKPIs {
    totalVendas: number;
    totalPares: number;
    totalClientes: number;
    margemTotal: number;
    margemPercentual: number;
}

export interface LineChartPoint {
    DataDia: Date | string;
    totalVenda: number;
    totalMargem: number;
}

export interface LineData {
    linha: string;
    totalVenda: number;
    totalMargem: number;
    participacao: number;
}

export interface ProductData {
    name: string;
    totalRevenue: number;
    totalVolume: number;
}

export interface InactiveClientData {
    name: string;
    ultimaCompra: string;
    totalHistorico: number;
    uf: string;
    cidade?: string;
    ibge?: number | null;
}

export interface RegionsAPIResponse {
    statesData: StateData[];
    kpis: RegionsKPIs;
    lineChartData: LineChartPoint[];
    linesData: LineData[];
    clientsData: ClientData[];
    previousPeriodKpis?: RegionsKPIs; // Adiciona o campo para KPIs anteriores
    productsData?: ProductData[];
    inactiveClients?: InactiveClientData[];
    cached?: boolean;
    cachedAt?: string;
}

export interface ClientData {
    cliente: string;
    uf: string;
    cidade?: string;
    ibge?: number | null;
    totalVenda: number;
    totalMargem: number;
    participacao: number; // 0-1
}

/**
 * Busca a lista de estados (UFs) para o filtro
 */
export const fetchStatesList = () => {
    // Retorna um array de strings, ex: ["SP", "PR", "SC"]
    return api.get<string[]>('/regions/states-list');
};

/**
 * Busca os dados de vendas por região
 */
export const fetchRegionsSalesData = (
    dataI: string,
    dataF: string,
    preset: DatePreset | undefined,
    carteiraId?: string,
    estado?: string,
    cliente?: string,
    linha?: string,
    refresh?: boolean
) => {
    
    return api.get<RegionsAPIResponse>('/regions/sales-data', { 
        params: { dataI, dataF, preset, carteiraId, estado, cliente, linha, refresh: refresh ? 'true' : undefined } 
    });
};

/**
 * Busca produtos comprados por um cliente para o modal de detalhe nas regiões
 */
export const fetchRegionsClientProducts = (
    clientName: string,
    dataI: string,
    dataF: string,
    carteiraId?: string
) => {
    return api.get<{ clientProducts: any[] }>('/regions/client-products', {
        params: { clientName, dataI, dataF, carteiraId }
    });
};